import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IViewBase } from '../../../../ts/models/IViewInfo';
import { SiteRolesResource } from '../../../../ts/resources/SiteRoles';
import { whoHasSeenThisView } from '../../../actions/spaces/WhoHasSeenThisViewAction';
import { SessionSiteSelectors, SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { getOwnerIdForView } from '../../../utils/MixedContentHelpers';
import { IEntityAction } from './IEntityAction';

export const WhoHasSeenThisViewEntityAction: IEntityAction<IContentInfo | IViewBase, {}> = {
  name: 'who_has_seen_this_view',
  translateName: Messages.whoHasSeenThisView,
  isVisible: (targetItems: IContentInfo[]) => targetItems.length === 1,
  isClickable: (availableActions: {}, targetItems: IContentInfo[] | IViewBase[], state: AppState) => {
    return SessionUserSelectors.isSessionServerAdmin(state) ||
      SiteRolesResource.isSiteAdmin(SessionSiteSelectors.siteRole(state)) ||
      getOwnerIdForView(targetItems[0]) === SessionUserSelectors.sessionUserId(state);
  },
  createReduxAction: (targetItems: IContentInfo[]) => whoHasSeenThisView(targetItems[0])
};
